import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock";

const Navbar = ({ onRegister, onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#1b140e]/90 backdrop-blur-md shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <img src="/alramz-logo.png" alt="الرمز Alramz" className="h-11 w-auto object-contain" />
        </a>

        {/* Desktop links */}
        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className="text-sm text-stone-200/90 hover:text-[#D9C08A] transition-colors font-500"
            >
              {l.label}
            </button>
          ))}
          <span className="text-sm text-stone-300">English</span>
        </nav>

        {/* CTAs */}
        <div className="hidden lg:flex items-center gap-3">
          <button
            onClick={onRegister}
            className="px-5 py-2.5 rounded-xl bg-[#BF9A5A] hover:bg-[#a9853f] text-white text-sm font-700 transition-colors"
          >
            سجل اهتمامك
          </button>
          <button
            onClick={onBook}
            className="px-5 py-2.5 rounded-xl bg-white/10 hover:bg-white/20 border border-white/25 text-white text-sm font-700 transition-colors"
          >
            احجز الآن
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#1b140e]/97 backdrop-blur-md px-5 pb-6 pt-2 flex flex-col gap-1">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className="text-right py-3 text-stone-200 border-b border-white/10"
            >
              {l.label}
            </button>
          ))}
          <div className="flex gap-3 mt-4">
            <button onClick={() => { setOpen(false); onRegister(); }} className="flex-1 py-3 rounded-xl bg-[#BF9A5A] text-white font-700">سجل اهتمامك</button>
            <button onClick={() => { setOpen(false); onBook(); }} className="flex-1 py-3 rounded-xl border border-white/25 text-white font-700">احجز الآن</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
